(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onDocumentTouch = this.onDocumentClick.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.mobileSearch = this.querySelector('.header__search-unified');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('touchstart', this.onDocumentTouch, { passive: true });

      // Run drawer populator immediately
      this.decorateMobileMenuIcons();
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('touchstart', this.onDocumentTouch);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onDocumentClick(event) {
      if (!this.mobileSearch || !this.mobileSearch.hasAttribute('open')) return;
      if (this.mobileSearch.contains(event.target)) return;
      this.mobileSearch.removeAttribute('open');
    }

    decorateMobileMenuIcons() {
      const drawerMenu = this.querySelector('.menu-drawer__menu');
      const utilityContainer = this.querySelector('.menu-drawer__utility-links');

      if (!drawerMenu || drawerMenu.dataset.customized === 'true') return;

      const topMenuEl = this.querySelector('[data-mobile-top-menu]');
      const bottomMenuEl = this.querySelector('[data-mobile-bottom-menu]');

      const mobileItems = topMenuEl ? JSON.parse(topMenuEl.textContent) : [];
      const bottomItems = bottomMenuEl ? JSON.parse(bottomMenuEl.textContent) : [];

      drawerMenu.innerHTML = '';

      // Main Menu Populator
      mobileItems.forEach((item) => {
        const li = document.createElement('li');
        const link = document.createElement('a');

        link.href = item.url;
        link.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';

        // Additional safety replace
        let cleanTitle = item.title.replace(/>/g, '').replace(/›/g, '').replace(/&#8250;/g, '').trim();
        const text = document.createElement('span');
        text.textContent = cleanTitle;
        
        link.appendChild(text);
        li.appendChild(link);
        drawerMenu.appendChild(li);
      });

      drawerMenu.dataset.customized = 'true';

      // Utility Links Populator
      if (utilityContainer) {
        utilityContainer.innerHTML = '';

        bottomItems.forEach((item) => {
          if (!item.title) return;
          const link = document.createElement('a');
          link.href = item.url;
          link.className = 'menu-drawer__utility-item link link--text focus-inset';
          
          let cleanTitle = item.title.replace(/>/g, '').replace(/›/g, '').replace(/&#8250;/g, '').trim();
          link.textContent = cleanTitle;
          
          utilityContainer.appendChild(link);
        });
      }
    }

    onResize() {
      this.decorateMobileMenuIcons();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      if (this.mobileSearch) this.mobileSearch.removeAttribute('open');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
